import * as React from 'react';
import LogsTable from '../components/LogsTable';
import useLogs from '../hooks/useLogs';

const LogsTableContainer: React.FC = () => {
  const { logs, isLoading, fetchLogs, needRefresh } = useLogs();

  return <LogsTable logs={logs} getMoreLogs={fetchLogs} isLoading={isLoading} needRefresh={needRefresh} />;
};

export default LogsTableContainer;
